export enum ChatType {
	LANDING_PAGE = 'landing_page',
	BESTFIT = 'bestfit',
	CHAT_IN_DRAWER = 'chat_in_drawer',
}